import './Navbar.css'
function Navbar() {
  return (
     <nav class="navbar navbar-expand-lg navbar-light bg-light">
      
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <a class="nav-link active" >
            GREEN POWER TECH
           
          </a>
          <a class="nav-link" href="#about">about</a>
          <a class="nav-link" href="#home">Hero</a>
          <a class="nav-link" href="#catalogue">catalogue</a>
          <a class="nav-link" href="#services">Services</a>
          <a class="nav-link" href="#contact">Contact</a>
           <a class="nav-link" href="#footer">Footer</a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
